import db from "@/database";
import { TherapyStatusEnum } from "@/domains/therapy/shared/application/therapy-status.enum";

export const findNotSynced = () =>
  db.therapy
    .where("status")
    .equals(TherapyStatusEnum.NOT_SYNCED)
    .or("synced")
    .equals(0)
    .toArray();

export const createOrUpdate = (therapy) => db.therapy.put(therapy);

export const deleteOne = (localId) => db.therapy.delete(localId);

export const deleteAll = () => db.therapy.clear();

/**
 * 🔥 Remove terapias órfãs do IndexedDB que tenham draftId
 * (após refatoração, terapias com draft devem estar apenas na nuvem)
 */
export const cleanupOrphanDrafts = async () => {
  try {
    const therapiesWithDraftId = await db.therapy
      .filter((t) => t.draftId !== null && t.draftId !== undefined)
      .toArray();

    if (therapiesWithDraftId.length > 0) {
      //console.log(
      //  `[Cleanup] 🧹 Removendo ${therapiesWithDraftId.length} terapia(s) órfã(s) do IndexedDB`
      //);

      for (const therapy of therapiesWithDraftId) {
        await db.therapy.delete(therapy.localId);
        //console.log(
        //  "[Cleanup] ✅ Terapia órfã removida - localId:",
        //  therapy.localId,
        //  "draftId:",
        //  therapy.draftId
        //);
      }

      return therapiesWithDraftId.length;
    }

    return 0;
  } catch (error) {
    console.error("[Cleanup] Erro ao limpar terapias órfãs:", error);
    return 0;
  }
};
